import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export class IdentidadeAutenticarProps {
    public constructor(
        public email: string = '',
        public senha: string = '',
        public filtros?: {
            contratoId?: string
        }
    ) { }
}

export function usePostIdentidadeAutenticar() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const postIdentidadeAutenticar = useCallback(
        (autenticacaoProps: IdentidadeAutenticarProps) =>
            invocarApi({
                method: 'POST',
                url: `/${VariaveisAmbiente.apiVersion}/Auth/token-email`,
                data: autenticacaoProps,
                enviarTokenUsuario: false
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        postIdentidadeAutenticar,
    };
}
